import logger from '../utils/logger';
import React, { useEffect, useState, useRef } from 'react';
import '../style/PDFResultsModal.css';

const PDFModalDocumentsViewer = ({ document_id, onClose }) => {
  // logger.log(document_id);
  const [pdfUrl, setPdfUrl] = useState(null);
  const BASE_URL = process.env.REACT_APP_API_URL;
//   const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
//   const scrollContainerRef = useRef(null);


  useEffect(() => {
    const fetchPDF = async () => {
      try {
        const pdfName = `RIS_ORDERS/HealthGuardian_${document_id}.pdf`;
        const res = await fetch(`${BASE_URL}/upload/generate-signed-url?pdfName=${pdfName}`);
        const data = await res.json();
        // logger.log(data);
        setPdfUrl(data.signedUrl);
      } catch (error) {
        logger.error('Error fetching PDF:', error);
      }
    };
    if (document_id) fetchPDF();
  }, [document_id]);

  useEffect(() => {
    
  }, [pdfUrl]);

  const handleAcknowledge = () => {
    // logger.log('PDF acknowledged');
    onClose();
  };

  if (!document_id) return null;

  return (
    <div className="pdfViewer-modal-overlay open">
      <div className="pdfViewer-modal-content">
        <div
        //   ref={scrollContainerRef}
          style={{
            width: '100%',
            height: '80vh', // Adjust height as needed
            overflowY: 'auto',
          }}
        >
          {pdfUrl ? (
            <iframe
              src={pdfUrl}
              title="PDF Viewer"
              width="100%"
              height="100%"
              className="pdfViewer-modal-element"
              style={{ border: 'none' }}
            />
          ) : (
            <p>Loading PDF...</p>
          )}
        </div>
        <div className="pdfViewer-modal-footer">
          {/* <button
            className="pdfViewer-acknowledge-button"
            onClick={handleAcknowledge}
            disabled={!hasScrolledToBottom}
          >
            I Acknowledge
          </button> */}
          <button className="pdfViewer-close-button" onClick={onClose}>Close</button>
          {/* <p>By clicking I Acknowledge, you agree that you have read the form in its entirety</p> */}
        </div>
      </div>
    </div>
  );
};

export default PDFModalDocumentsViewer;